import {EnvironmentModel} from './environment.model';
import {environments} from './environments';

// tslint:disable-next-line:class-name
export class environment {
  private static envCache: EnvironmentModel | null = null;

  private static readonly defaultEnvironmentHostname = 'my.busy-fly.com';

  private static get currentEnvironment(): EnvironmentModel {
    if (environment.envCache === null) {
      const hostname = window.location.hostname;
      environment.envCache = hostname in environments ?
        environments[hostname] : environments[this.defaultEnvironmentHostname];
    }
    return this.envCache;
  }
  public static get production(): boolean {
    return environment.currentEnvironment.production;
  }
  public static get version(): string {
    return environment.currentEnvironment.version;
  }
  public static get authLoginUrl(): string {
    return environment.currentEnvironment.authLoginUrl;
  }
  public static get authLogoutUrl(): string {
    return environment.currentEnvironment.authLogoutUrl;
  }
  public static get authLoginAs(): string {
    return environment.currentEnvironment.authLoginAs;
  }
  public static get apiBasepoint(): string {
    return environment.currentEnvironment.apiBasepoint;
  }
  public static get publicApiBasepoint() {
    return environment.currentEnvironment.publicApiBasepoint;
  }
  public static get supportedLanguages(): string[] {
    return environment.currentEnvironment.supportedLanguages;
  }
  public static get defaultLanguage(): string {
    return environment.currentEnvironment.defaultLanguage;
  }
  public static get documentation(): string {
    return environment.currentEnvironment.documentation;
  }
  public static get configUrl() {
    return environment.currentEnvironment.configUrl;
  }
  public static get webStompUrl(): string {
    return environment.currentEnvironment.webStompUrl;
  }
  public static get webStompLogin() {
    return environment.currentEnvironment.webStompLogin;
  }
  public static get webStompPassword() {
    return environment.currentEnvironment.webStompPassword;
  }
  public static get mapTileBaseUrl() {
    return environment.currentEnvironment.mapTileBaseUrl;
  }
}
